'use strict';

var index = require('./lib/index');
var types = require('./lib/types');



Object.keys(index).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return index[k]; }
	});
});
Object.keys(types).forEach(function (k) {
	if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
		enumerable: true,
		get: function () { return types[k]; }
	});
});
